(function() {
    angular
        .module('validation.rule', ['validation'])
        .config(['$validationProvider', function($validationProvider) {

            var expression = {
                required: function(value) {
                    // if(angular.isUndefined(value))return false;
                    return !!value;
                },
                url: function(value) {
                    if (!value) return true;
                    var URL_REGEXP = /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/;
                    return URL_REGEXP.test(value);
                },
                email: function(value) {
                    if (!value) return true;
                    var EMAIL_REGEXP = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
                    return EMAIL_REGEXP.test(value);
                },
                number: function(value) {
                    /*if(!value)return true;
                    var NUMBER_REGEXP = /^\d+$/;
                    return NUMBER_REGEXP.test(value);*/
                    return !isNaN(value);
                },
                minlength: function(value, scope, element, attrs, param) {
                    if (!value) return true;
                    return value.length >= param;
                },
                maxlength: function(value, scope, element, attrs, param) {
                    if (!value) return true;
                    return value.length <= param;
                },
                spechar: function(value) {
                    if (!value) return true;
                    var SPECIALCHAR_REGEXP = /[<>\/]/;
                    return !SPECIALCHAR_REGEXP.test(value);
                },
                custommonitorSpechar: function(value) {
                    if (!value) return true;
                    var CUSTOMMONITORSPECHAR_REGEXP = /[%<>\/+]/;
                    return !CUSTOMMONITORSPECHAR_REGEXP.test(value);
                },
                idcard: function(value) {
                    if (!value) return true;
                    var IDCARD_REGEXP = /^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X|x)$/;
                    return IDCARD_REGEXP.test(value);
                },
                telephone: function(value) {
                    if (!value) return true;
                    var TELPHONE_RETEXP = /(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7}/;
                    return TELPHONE_RETEXP.test(value);
                },
                mobilephone: function(value) {
                    if (!value) return true;
                    // var MOBILEPHONE_REGEXP = /^(0|86|17951)?(13[0-9]|15[0-9]|17[0-9]|18[0-9]|14[0-9])[0-9]{8}$/;
                    var MOBILEPHONE_REGEXP = /^(1[2-9][0-9])\d{8}$/;
                    return MOBILEPHONE_REGEXP.test(value);
                },
                englishAndNum: function(value) {
                    if (!value) return true;
                    var ENGLISHANDNUM_RETEXP = /^[a-zA-Z0-9]+$/;
                    return ENGLISHANDNUM_RETEXP.test(value);
                },
                ipconfig: function(value) {
                    if (!value) return true;
                    var IPCONFIG_RETEXP = /^(25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[1-9])\.(25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[1-9]|0)\.(25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[1-9]|0)\.(25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[0-9])$/;
                    return IPCONFIG_RETEXP.test(value);
                },
                haschinese: function(value) {
                    if (!value) return true;
                    var HASCHINESE_RETEXP = /^[^\u4e00-\u9fa5]*$/;
                    return HASCHINESE_RETEXP.test(value);
                },
                allchar: function(value) {
                    if (!value) return true;
                    var ALLCHAR_RETEXP = /(?=[\x21-\x7e“”‘’、·？！（）【】]+)[^A-Za-z0-9]/;
                    return !ALLCHAR_RETEXP.test(value);
                },
                hasletter: function(value) {
                    if (!value) return true;
                    var NOLETTER_RETEXP = /[A-Za-z]+/;
                    return !NOLETTER_RETEXP.test(value);
                },
                filepath: function(value) {
                    if (!value) return true;
                    var FILEPATH_RETEX = /^[A-Za-z]:(?:\\(?!\\)|[^\\/:*?“”‘’''""<>|+-.`~#%^&;])+$/;
                    return FILEPATH_RETEX.test(value);
                },
                password: function(value) {
                    if (!value) return true;
                    var PASSWORD_RETEX = /(?!^[a-z]+$)(?!^[A-Z]+$)(?!^[0-9]+$)(?!^[·~!@#$%\^&*()_\-=+{}\[\]【】\\|:;'",.<>/?]+$)(?!^[^\x21-\x7e]+$)^.+$/;
                    return PASSWORD_RETEX.test(value);
                },
                newFolder: function(value) {
                    if (!value) return true;
                    var NEWFOLDER_RETEXP = /^[~|\$|\.|_].*/;
                    return !NEWFOLDER_RETEXP.test(value);
                },
                numb: function(value) {
                    /*if (!value) return true;
                    var NUMB_RETEXP = /^[-+]?\d*$/;
                    return !NUMB_RETEXP.test(value);*/
                    return !isNaN(value) && Number(value) > 0;
                },
                price: function(value) {
                    if (!value) return true;
                    var PRICE_REXTEP = /^[\d\-.]+$/;
                    return PRICE_REXTEP.test(value);
                },
                codeNum: function(value) {
                    if (!value) return false;
                    var reg = /[\u4E00-\u9FA5]/;
                    var quantity = 0;
                    for (var i in value) {
                        reg.test(value[i]) ? quantity += 2 : quantity += 1;
                    }
                    if(quantity>=2&&quantity<=20){
                        return true;
                    }else{
                        return false;
                    }
                },
                chineseJudgment:function(value){//中文判断且文字限制在1-20个字
                    if(!value)return true;
                    var reg = /[\u4E00-\u9FA5]/;
                    for(var i in value){
                        if(!reg.test(value[i])){
                            return false;
                        }
                    }
                    return true;
                }
            };

            var defaultMsg = {
                required: {
                    error: '这是必填项！',
                    success: 'It\'s Required'
                },
                url: {
                    error: 'url格式不正确！',
                    success: 'It\'s Url'
                },
                email: {
                    error: '请输入正确的邮箱地址',
                    success: 'It\'s Email'
                },
                number: {
                    error: '请输入数字',
                    success: 'It\'s Number'
                },
                minlength: {
                    error: '长度太短了！',
                    success: 'Long enough!'
                },
                maxlength: {
                    error: '长度太长了！',
                    success: 'Short enough!'
                },
                spechar: {
                    error: '不能包含特殊字符！',
                    success: '正确'
                },
                custommonitorSpechar: {
                    error: '不能包含特殊字符！',
                    success: '正确'
                },
                idcard: {
                    error: '身份证号码错误！',
                    success: '正确'
                },
                telephone: {
                    error: '固定电话格式错误！',
                    success: '正确'
                },
                mobilephone: {
                    error: '手机号码错误',
                    success: '正确'
                },
                englishAndNum: {
                    error: '请输入只含有英文字母、数字的名称',
                    success: '正确'
                },
                ipconfig: {
                    error: '请输入正确输入服务器地址.',
                    success: '正确'
                },
                haschinese: {
                    error: "不能包含汉字",
                    success: "正确"
                },
                allchar: {
                    error: "不能包含符号",
                    success: "正确"
                },
                hasletter: {
                    error: "不能包含字母",
                    success: "正确"
                },
                filepath: {
                    error: "请输入正确的文件存放路径",
                    success: "正确"
                },
                password: {
                    error: "须包含大写字母、小写字母、数字、特殊字符中的2种",
                    success: "正确"
                },
                newFolder: {
                    error: "不能以~ 、. 、 _ 、 $ 开头",
                    success: "正确"
                },
                numb: {
                    error: "请填写一个正数",
                    success: "正确"
                },
                price: {
                    error: "只能输入正整数，小数点，和 - 连接符",
                    success: "正确"
                },
                codeNum:{
                    error: "2-20个字符，由汉字，英文字母，数字，点或下划线组成",
                    success: "正确"
                },
                chineseJudgment:{
                    error: "请输入您的真实姓名",
                    success: "正确"
                }
            };
            $validationProvider.setExpression(expression).setDefaultMsg(defaultMsg);
        }]);
}).call(this);
